import React from 'react';
import { Icon } from '@iconify/react';

const OrderSummary = ({ cart, cartCount, subtotal, shippingCost, total, deliveryData }) => {
    return (
        <div className="lg:col-span-1">
            <div className="bg-white dark:bg-store-dark border border-slate-200 dark:border-store-border rounded-2xl p-5 sticky top-24 space-y-4">
                <h3 className="font-bold text-base flex items-center gap-2">
                    <Icon icon="solar:cart-large-bold-duotone" className="text-lime-500" />
                    Votre commande ({cartCount})
                </h3>

                {/* Cart items */}
                <div className="space-y-3 max-h-[300px] overflow-y-auto pr-1">
                    {cart.map((item) => (
                        <div
                            key={item.cartId}
                            className="flex gap-3 p-2 bg-slate-50 dark:bg-store-gray-dark/30 rounded-xl"
                        >
                            <img
                                src={item.images[0]}
                                alt={item.name}
                                className="w-14 h-14 object-cover rounded-lg flex-shrink-0"
                            />
                            <div className="flex-1 min-w-0">
                                <p className="text-xs font-semibold line-clamp-1">
                                    {item.name}
                                </p>
                                {item.selectedOptions && Object.keys(item.selectedOptions).length > 0 && (
                                    <p className="text-[9px] text-slate-400 dark:text-store-gray truncate">
                                        {Object.entries(item.selectedOptions).map(([optId, valId]) => {
                                            const opt = item.options?.find(o => o.id === optId);
                                            const val = opt?.values.find(v => v.id === valId);
                                            return val?.label;
                                        }).join(', ')}
                                    </p>
                                )}
                                <p className="text-[10px] text-slate-500 dark:text-store-gray">
                                    x{item.qty}
                                </p>
                                <p className="text-xs font-bold text-lime-600 dark:text-lime-400">
                                    {(item.price * item.qty).toFixed(2)} $US
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Totals */}
                <div className="border-t border-slate-200 dark:border-store-border pt-3 space-y-2 text-sm">
                    <div className="flex justify-between text-slate-500 dark:text-store-gray">
                        <span>Sous-total</span>
                        <span>{subtotal.toFixed(2)} $US</span>
                    </div>
                    <div className="flex justify-between text-slate-500 dark:text-store-gray">
                        <span>Livraison</span>
                        <span
                            className={
                                shippingCost === 0
                                    ? 'text-lime-500 font-semibold'
                                    : ''
                            }
                        >
                            {deliveryData
                                ? shippingCost === 0
                                    ? 'Gratuit'
                                    : `${shippingCost.toFixed(2)} $US`
                                : '—'}
                        </span>
                    </div>
                    <div className="flex justify-between font-bold text-base pt-2 border-t border-slate-200 dark:border-store-border">
                        <span>Total</span>
                        <span className="text-lime-600 dark:text-lime-400">
                            {total.toFixed(2)} $US
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderSummary;
